import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import * as api from '../../../services/api'
import { useSnackbar } from 'notistack'
import moment from 'moment';

function UpdateModal(props) {
  const {
    open,
    newApptInfo,
    selectedApptInfo,
    onClose,
    provider,
    refeshAppointments,
    classes: { dialogFooter, action, dialogContent },
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const update = async () => {
    try {
      const where = {
        id: selectedApptInfo.id
      }
      const newInfo = {
        tenancyId: newApptInfo.tenancyId,
        durationMinutes: newApptInfo.durationMinutes,
        time: newApptInfo.time,
      }
      // Check user timezone
      const currentUserTimezone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Convert UTC to America/New_York time, automatically handling DST
      const estTime = new Date(newInfo.time);
      const apptHour = estTime.getHours();
      
      if (
        currentUserTimezone !== 'America/New_York' ||
        apptHour < 6 ||
        apptHour > 22
      ) {
        alert(
          '⚠️ Time Zone Mismatch Detected:\n' +
            'Kindly switch your system time zone to "America/New_York, EST" to proceed further.'
        );
        return;
      }
      await api.alterAppt(where, newInfo);
      refeshAppointments(selectedApptInfo.providerId)
      onClose()
      enqueueSnackbar('Appointment updated successfully.')
    } catch (err) {
      enqueueSnackbar('Failed to update appointment, sorry about that.')
    }
  }

  return newApptInfo.tenancyId ? (
    <>
      <Dialog fullWidth open={open} onClose={onClose} maxWidth="md">
        <DialogTitle>Update Appointment</DialogTitle>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Patient</TableCell>
              <TableCell>Provider</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Location</TableCell>
              <TableCell>Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Previous </TableCell>
              <TableCell>{selectedApptInfo.patientName} </TableCell>
              <TableCell>{selectedApptInfo.providerFullTitle}</TableCell>
              <TableCell>
                {moment(selectedApptInfo.time).format('MMMM Do YYYY, h:mm a')}{' '}
              </TableCell>
              <TableCell>{selectedApptInfo.tenancyLocation} </TableCell>
              <TableCell>
                {selectedApptInfo.durationMinutes}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>New</TableCell>
              <TableCell>{newApptInfo.patientName} </TableCell>
              <TableCell>{provider.fullTitle}</TableCell>
              <TableCell>
                {moment(newApptInfo.time).format('MMMM Do YYYY, h:mm a')}{' '}
              </TableCell>
              <TableCell>{newApptInfo.tenancyLocation} </TableCell>
              <TableCell>{newApptInfo.durationMinutes} </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <DialogContent className={dialogContent}>
          {`Are you sure you would like to update the above appointment? Once you
          hit confirm, a notification email will be sent to the patient
          ${provider.fullTitle !== selectedApptInfo.providerFullTitle ? ' and the new provider' : ''}
          about the change.`}
        </DialogContent>

        <DialogActions className={dialogFooter}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="primary"
            className={action}
          >
            Back
          </Button>
          <Button
            onClick={update}
            variant="outlined"
            color="secondary"
            className={action}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  ) : (<div></div>);
}

const styles = () => ({
  dialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ADADAD',
  },
  dialogContent: {
    paddingTop: '2em',
  },
  button: {
    backgroundColor: '#424B5A',
    color: 'white',
  },
  action: {
    marginLeft: '5px',
  },
  danger: {
    color: '#F44336',
  },
});

export default withStyles(styles)(UpdateModal);
